import React,{useEffect, useState} from 'react'
import { auth, db } from "./firebase";
import './Display.css'
function Display() {
    const [messages, setMessages]=useState([])
    const getAllMessages=(e)=>{
       
        db.collection("Messages").orderBy("timestamp").onSnapshot((querySnapshot)=>{
            const items=[]
            querySnapshot.forEach((doc)=>{
                items.push(doc.data())
            })
            setMessages(items)
        })
    }
    useEffect(()=>{
        getAllMessages()
    },[])
    return (
        <div className="display_main">
            <div className="display_box">
                {   
                    messages.map((message)=>(
                        <div key={message.id} className="messages_box">
                            <h2>{message.Uname}</h2>
                            <p>{message.Message}</p>
                            
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default Display
